import * as React from 'react';
import { useState, useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import {
 Box,
 TextField,
 Select,
 MenuItem,
 FormControl,
 InputLabel,
 FormHelperText,
 Snackbar,
 Alert,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ru } from 'date-fns/locale';
import { ContentWrapper } from '../../_common';
import SelectContract from '../../_common/SelectContract';
import { SubmitButton } from './СonnectionDocuments.styled';
import DownloadDoc from './DownloadDoc';
import srv from '../../../services';
import SuccessModal from './Modal/SuccessModal';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
 dropDown: {
  fontSize: '14px !important',
  height: '32px !important',
  '& .MuiSelect-select': {
   height: '32px !important',
   boxSizing: 'border-box !important',
   display: 'flex !important',
   alignItems: 'center !important',
   paddingTop: 0,
   paddingBottom: 0,
   fontSize: '12px !important',
  },
 },
 menuItem: {
  fontSize: '12px !important',
  paddingY: '6px !important',
 },
 email: {
  width: '280px !important',
  marginLeft: '-10px !important',
  '& .MuiInputBase-root': {
   height: '32px !important',
   fontSize: '13px !important',
  },
  '& .MuiSelect-select': {
   fontSize: '13px !important',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px !important',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px !important',
  },
 },
 datePicker: {
  width: '380px !Important',
  '& .MuiInputBase-root': {
   height: '32px !Important',
   fontSize: '13px !Important',
  },
  '& .MuiSelect-select': {
   fontSize: '13px !Important',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px !Important',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px !Important',
  },
 },
 datePickerRight: {
  width: '380px !Important',
  marginLeft: '-10px',
  '& .MuiInputBase-root': {
   height: '32px !Important',
   fontSize: '13px !Important',
  },
  '& .MuiSelect-select': {
   fontSize: '13px !Important',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px !Important',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px !Important',
  },
 },
});

const EMAIL_REGEX =
 /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const СonnectionDocuments = () => {
 const queryClient = useQueryClient();
 const contracts =
  queryClient.getQueryData<Models.Contract[]>('contracts') || [];

 const classes = useStyles();

 const [contractAisId, setContractAisId] = useState<number | null>(null);
 const [docConnection, setDocConnection] = useState<string>('');
 const [startDate, setStartDate] = useState<any>(null);
 const [endDate, setEndDate] = useState<any>(null);
 const [email, setEmail] = useState<string>('');

 const [snackbar, setSnackbar] = useState({
  open: false,
  message: '',
 });

 const handleCloseSnackbar = () => {
  setSnackbar((prev) => ({ ...prev, open: false }));
 };

 const [errors, setErrors] = useState<{
  docConnection?: string;
  period?: string;
  email?: string;
 }>({});
 const [modalVisible, setModalVisible] = useState(false);

 const selectedContract = contracts.find((i) => i.id === contractAisId);
 const isButtonVisible =
  contractAisId && docConnection === '9' && startDate && endDate && email;

 useEffect(() => {
  if (docConnection)
   setErrors((prev) => ({ ...prev, docConnection: undefined }));
 }, [docConnection]);
 useEffect(() => {
  if (startDate || endDate)
   setErrors((prev) => ({ ...prev, period: undefined }));
 }, [startDate, endDate]);
 useEffect(() => {
  if (email) setErrors((prev) => ({ ...prev, email: undefined }));
 }, [email]);

 const { data, mutate: save } = useMutation(srv.requestDocuments, {
  onSuccess: () => {
   setContractAisId(null);
   setDocConnection('');
   setStartDate(null);
   setEndDate(null);
   setEmail('');
   setErrors({});
   setModalVisible(true);
  },
  onError: (errorMessage: string) => {
   setSnackbar({
    open: true,
    message:
     typeof errorMessage === 'string'
      ? errorMessage
      : 'Произошла ошибка при запросе',
   });
  },
 });

 const handleContractChange = (val: number) => {
  setContractAisId(val);
  setDocConnection('');
  setStartDate(null);
  setEndDate(null);
  setEmail('');
  setErrors({});
 };

 const handleDocTypeChange = (val: string) => {
  setDocConnection(val);
  setStartDate(null);
  setEndDate(null);
  setEmail('');
  setErrors((prev) => ({ ...prev, period: undefined, email: undefined }));
 };

 const handleSubmit = (e?: React.FormEvent) => {
  if (e) e.preventDefault();

  if (!selectedContract) {
   console.warn(
    'Контракт не найден. Выбранный ID:',
    contractAisId,
    'Доступные контракты:',
    contracts,
   );
   return;
  }

  const newErrors: typeof errors = {};
  if (!docConnection) newErrors.docConnection = 'Выберите тип документа';

  if (docConnection === '9') {
   if (!startDate || !endDate) newErrors.period = 'Укажите период';
   if (!email) {
    newErrors.email = 'Введите E-mail';
   } else if (!EMAIL_REGEX.test(email.toLowerCase())) {
    newErrors.email = 'Неверный адрес электронной почты';

    setSnackbar({
     open: true,
     message: newErrors.email,
    });
   }
  }

  if (Object.keys(newErrors).length > 0) {
   setErrors(newErrors);
   return;
  }

  const formattedStart =
   typeof startDate.format === 'function'
    ? startDate.format('YYYY-MM-DDTHH:mm:ss.SSS')
    : new Date(startDate).toISOString();
  const formattedEnd =
   typeof endDate.format === 'function'
    ? endDate.format('YYYY-MM-DDTHH:mm:ss.SSS')
    : new Date(endDate).toISOString();

  save({
   contractId: selectedContract.aisId,
   eMail: email,
   documentsType: [Number(docConnection)],
   startDate: formattedStart,
   endDate: formattedEnd,
  });
 };

 return (
  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
   <ContentWrapper>
    <Box
     component="form"
     onSubmit={handleSubmit}
     noValidate
     sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}
    >
     <Box
      sx={{
       width: '100%',
       display: 'flex',
       flexDirection: 'row',
       gap: '20px',
       alignItems: 'flex-start',
      }}
     >
      <Box>
       <SelectContract
        contracts={contracts}
        changeContract={handleContractChange}
        value={contractAisId}
       />
      </Box>

      {contractAisId && (
       <FormControl
        error={!!errors.docConnection}
        sx={{ width: '400px', marginLeft: '-30px' }}
        size="small"
       >
        <InputLabel id="doc-type-label" sx={{ fontSize: '12px' }}>
         Выберите тип документа
        </InputLabel>
        <Select
         labelId="doc-type-label"
         value={docConnection}
         label="Выберите тип документа"
         onChange={(e) => handleDocTypeChange(e.target.value as string)}
         className={classes.dropDown}
        >
         <MenuItem value="1" className={classes.menuItem}>
          Проект договора энергоснабжения
         </MenuItem>
         <MenuItem value="2" className={classes.menuItem}>
          Дополнительное соглашение по тех. присоединению
         </MenuItem>
         <MenuItem value="3" className={classes.menuItem}>
          Акт о тех. присоединении
         </MenuItem>
         <MenuItem value="4" className={classes.menuItem}>
          Акт допуска ПУ в эксплуатацию
         </MenuItem>
         <MenuItem value="9" className={classes.menuItem}>
          Результаты контрольных показаний
         </MenuItem>
        </Select>
        {errors.docConnection && (
         <FormHelperText>{errors.docConnection}</FormHelperText>
        )}
       </FormControl>
      )}

      {docConnection && docConnection !== '9' && (
       <DownloadDoc
        docConnection={docConnection}
        contractId={selectedContract?.aisId}
       />
      )}
     </Box>

     {docConnection === '9' && (
      <Box
       sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        marginTop: '20px',
        alignItems: 'flex-start',
       }}
      >
       <Box sx={{ width: '400px', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', gap: '20px' }}>
         <DatePicker
          label="Начало периода"
          value={startDate}
          onChange={(newValue) => setStartDate(newValue)}
          inputFormat="dd.MM.yyyy"
          renderInput={(params) => (
           <TextField
            {...params}
            size="small"
            error={!!errors.period}
            inputProps={{
             ...params.inputProps,
             style: { fontSize: '12px', height: '15px' },
            }}
            className={classes.datePicker}
           />
          )}
         />
         <DatePicker
          label="Окончание периода"
          value={endDate}
          onChange={(newValue) => setEndDate(newValue)}
          inputFormat="dd.MM.yyyy" // ИСПРАВЛЕНО: принудительно задаем правильный регистр для date-fns
          renderInput={(params) => (
           <TextField
            {...params}
            size="small"
            error={!!errors.period}
            inputProps={{
             ...params.inputProps,
             style: { fontSize: '12px', height: '15px' },
            }}
            className={classes.datePickerRight}
           />
          )}
         />
        </Box>
        {errors.period && (
         <FormHelperText error sx={{ marginLeft: '14px', marginTop: '4px' }}>
          {errors.period}
         </FormHelperText>
        )}
       </Box>

       <Box sx={{ width: '280px' }}>
        <TextField
         fullWidth
         size="small"
         placeholder="Введите E-mail"
         value={email}
         onChange={(e) => setEmail(e.target.value)}
         error={!!errors.email}
         helperText={errors.email}
         className={classes.email}
        />
       </Box>

       {isButtonVisible && (
        <SubmitButton type="submit" onClick={() => handleSubmit()}>
         Запросить
        </SubmitButton>
       )}
      </Box>
     )}

     <SuccessModal
      visible={modalVisible}
      handleCancel={() => setModalVisible(false)}
      data={data}
     />

     <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Позиция в правом верхнем углу
     >
      <Alert
       onClose={handleCloseSnackbar}
       severity="error"
       sx={{ width: '100%' }}
      >
       {snackbar.message}
      </Alert>
     </Snackbar>
    </Box>
   </ContentWrapper>
  </LocalizationProvider>
 );
};

export default СonnectionDocuments;
